import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeRevenueController', ChangeRevenueController);

    /** @ngInject */
    function ChangeRevenueController(
        $scope,
        $stateParams,
        CompaniesFactory,
        FormVerificationService,
        toastr,
        $state,
        ngDialog
    ) {
        var vm = this;

        init();

        function init() {
            vm.issue = $scope.ngDialogData.issue;
            vm.save = save;
        }

        function save() {
            CompaniesFactory.editIssue(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                { revenue: vm.issue.revenue }
            ).then(
                function () {
                    toastr.success('Zapisano zmiany');
                    ngDialog.close();
                    $state.reload('company_employee.issue_list');
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/revenue/revenue.controller.ts